import { useCallback } from 'react';

export const useWeglot = () => {
  const updateSiteLanguage = useCallback((lang) => {
    if (window.Weglot) {
      window.Weglot.switchTo(lang);
    } else {
      console.warn('Weglot is not loaded on the window object.');
    }
  }, []);

  return {
    updateSiteLanguage,
  };
};
